import React from "react";
import "./portfolio.css";
import IMG1 from "../../assets/portfolio1.png";
import IMG2 from "../../assets/portfolio2.png";
import IMG3 from "../../assets/portfolio3.png";
import IMG4 from "../../assets/portfolio4.png";
import IMG5 from "../../assets/portfolio5.png";
import IMG6 from "../../assets/portfolio6.png";

const data = [
  {
    id: 1,
    image: IMG1,
    title: "Neo-Commerce",
    github: "https://github.com/na2ib/neo-commerce",
    demo: "https://na2ib.github.io/neo-commerce/",
  },
  {
    id: 2,
    image: IMG2,
    title: "Vue Jobs",
    github: "https://github.com/na2ib/vue-job",
    demo: "https://zob-finder.netlify.app/",
  },
  {
    id: 3,
    image: IMG3,
    title: "Top Rated Manga",
    github: "https://github.com/na2ib/frontend",
    demo: "https://top-rated-manga.netlify.app/",
  },
  {
    id: 4,
    image: IMG4,
    title: "Course Taking",
    github: "https://github.com/na2ib/Course-taking",
    demo: "https://course-taking.netlify.app/signin",
  },
  {
    id: 5,
    image: IMG5,
    title: "PropLink",
    github: "https://github.com/na2ib/PropLink",
    demo: "https://proplink.netlify.app/",
  },
  {
    id: 6,
    image: IMG6,
    title: "Luffy Animation",
    github: "https://github.com/na2ib/luffy-animation",
    demo: "https://na2ib.github.io/luffy-animation/",
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                <a
                  href={github}
                  className="btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Github
                </a>
                <a
                  href={demo}
                  className="btn btn-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
